module.exports = __webpack_public_path__ + "static/media/menu.91e7de8a.svg";